import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingConfigurationPolicyActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/AccountingPolicy/AccountingPolicyBrowser")
	}

	render() {
		return (
			<Activity 
				name="AccountingConfigurationPolicy"
				RenderedComponent={this.RenderedComponent}
				context="AccountingConfigurationPolicy"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingConfigurationPolicyActivity)
